/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStorageStateHook } from './createStorageStateHook';
import { JsonSerializer, StringSerializer } from './serializers';
const sessionStorageProvider = () => window.sessionStorage;
export const useSessionStorageString = createStorageStateHook(sessionStorageProvider, StringSerializer);
export const useSessionStorageState = createStorageStateHook(sessionStorageProvider, JsonSerializer);
const localStorageProvider = () => window.localStorage;
export const useLocalStorageString = createStorageStateHook(localStorageProvider, StringSerializer);
export const useLocalStorageState = createStorageStateHook(localStorageProvider, JsonSerializer);
//# sourceMappingURL=useStorageState.js.map